import React, { Component } from "react";
import MainLayout from '../../mainLayout';

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//Service import 
import service from '../../services'

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

// Images import
import selectArrow from "../../assets/images/select-arrow.svg";
import plusIcon from "../../assets/images/plusIcon.svg";
import background from "../../assets/images/background.jpg";
import Loader from "../../component/loader";
import commonImage from "../../commonImage";

let sub;
const mapStateToProps = state => ({
    getPartnerDetails: state.getPartnerDetails,
    getLoginRole: state.getLoginRole
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

class PartnersProfileView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imagePreloader: false,
            createOpen: false,
            email: '',
            partnerName: '',
            partnerLogo: '',
            fname: '',
            lname: '',
            id: ''
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z . _']*)$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                }
            }
        });
        this.apiserve = new service();
    }

    componentDidMount = async () => {
        this.getPartner();
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "getUser":
                    if (!response.error) {
                        this.setState({
                            getPerticularPartner: response.data,
                            fname: response.data.fname,
                            lname: response.data.lname,
                            partnerName: response.data.partnerName,
                            partnerLogo: response.data.partnerLogo || '',
                            email: response.data.email,
                            id: response.data._id,
                        })
                    }
                    break;
                case "privateScreeningPartner|edit":
                    if (!response.error) {
                        this.apiserve.success('Partner user updated successful.')
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    getPartner = () => {
        const { getLoginRole } = this.props
        if (getLoginRole && getLoginRole.user) {
            this.apiserve.sendevent("getUser", {
                id: getLoginRole.user._id
            });
        }
    }

    onInputChangeDropDown = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            selectedDropdown: e.target.value
        });
    }

    validate = () => {
        let emailErr = '';
        let pName = '';
        let lnameErr = '';
        let fnameErr = '';
        if (!this.state.email) {
            emailErr = 'This field is required.'
        } else {
            if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                emailErr = 'Email address must be valid email.';
            }
            if (!this.state.partnerName) {
                pName = 'This field is required.'
            }
            if (!this.state.fname) {
                fnameErr = 'This field is required.'
            }
            if (!this.state.lname) {
                lnameErr = 'This field is required.'
            }

            this.setState({ emailErr, pName, lnameErr, fnameErr });
            if (emailErr || pName || fnameErr || lnameErr) {
                return false
            }
            return true
        }
    }

    submitFn = (e) => {
        e.preventDefault();
        const { email, partnerName, partnerLogo, fname, lname, id } = this.state
        const isValid = this.validate()
        if (isValid) {
            var data = {
                email: email,
                partnerName: partnerName,
                fname: fname,
                lname: lname,
                id: id
            }
            if (partnerLogo !== "") {
                data.partnerLogo = partnerLogo;
            }
            this.apiserve.sendevent("privateScreeningPartner|edit", data);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
        this.forceUpdate();
    }

    clearFn = () => {
        this.validator.hideMessages();
        this.setState({
            imagePreloader: false,
            email: '',
            partnerName: '',
            partnerLogo: '',
            fname: '',
            lname: '',
            isEdit: false,
            deleteFilm: ''
        })
    }
    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };


    onChangeFile(e) {
        e.stopPropagation()
        e.preventDefault();
        if(e.target.files[0]){
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {
                this.setState({
                    file: file,
                    // base64: reader.result
                }, () =>
                    setTimeout(() => {
                        this.imageUpload(file,event.target.result);
                    }, 0))
            }
        }
    }

    onChangeFile(e) {
        this.setState({ imagePreloader: true })
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            setTimeout(() => {
                this.imageUploadPanel(file,event.target.result);
            }, 0);
        };
    }

    imageUploadPanel = (file, img) => {
        var fileSet= commonImage(file,false,'',img)
        fileSet.then((value) => {
            this.setState({ partnerLogo: value, imagePreloader: false })
        });
    };

    render() {
        const { getPerticularPartner } = this.state;
        const { getLoginRole } = this.props;
        let profileName='';
        let data = JSON.parse(localStorage.getItem('persist:root'));
        if(data && data.profileName){
            profileName = JSON.parse(data.profileName);
        }
        return (
            <React.Fragment>
                <div className={`right_side_wrapper partnerView_wrapper ${getLoginRole && getLoginRole.user && getLoginRole.user.role === "partner" ? "partner_view_wrapper" : ""}`}>
                    <div className="dashboard_header profile_header">
                        <div className="searchBlock">
                            <span>{profileName && profileName.fname ? profileName.fname + ' ' + profileName.lname: ''}</span>
                        </div>
                    </div>
                    <div className="profilePartnerView_block">
                        <form>
                            <div className="details">
                                <div className="partnerLogo">
                                    <label>Partner Logo<span>(optional)</span></label>
                                    <div className='image_pre_loader'>
                                        <input id="myInput"
                                            type="file"
                                            ref={(ref) => this.upload = ref}
                                            style={{ display: 'none' }}
                                            onChange={this.onChangeFile.bind(this)}
                                            accept=".png, .jpg, .jpeg"
                                        />
                                        {this.state.imagePreloader ?
                                            <Loader />
                                            :
                                            <img src={this.state.partnerLogo ?
                                                this.apiserve.imageUrl + this.state.partnerLogo :
                                                background
                                            } />
                                        }
                                        <a onClick={() => { this.upload.click() }}><img src={plusIcon} /></a>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Partner Name</label>
                                    <div className="form_group_input">
                                        <input
                                            type="text"
                                            name="partnerName"
                                            id="partnerName"
                                            value={this.state.partnerName}
                                            onChange={this.onInputChange}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('partner name', this.state.partnerName, 'required|apostrophe')}</span>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Partner Email</label>
                                    <div className="form_group_input">
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            disabled={this.state.changeTitleName ? true : false}
                                            maxLength={255}
                                            value={this.state.email}
                                            onChange={this.onInputChange}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('email', this.state.email, 'required|email')}</span>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>First Name</label>
                                    <div className="form_group_input">
                                        <input
                                            type="text"
                                            name="fname"
                                            id="fname"
                                            maxLength={100}
                                            value={this.state.fname}
                                            onChange={this.onInputChange}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('firstname', this.state.fname, 'required|apostrophe')}</span>
                                    </div>
                                </div>
                                <div className="form_group">
                                    <label>Last Name</label>
                                    <div className="form_group_input">
                                        <input
                                            type="text"
                                            name="lname"
                                            id="lname"
                                            maxLength={100}
                                            value={this.state.lname}
                                            onChange={this.onInputChange}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('lastname', this.state.lname, 'required|apostrophe')}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="btn_wrapper">
                                <button className="grayBTN"
                                    type="button"
                                    onClick={() => this.clearFn()}
                                >Clear</button>
                                <button className="orangeBTN"
                                    type="button"
                                    disabled={this.state.imagePreloader ? true : false}
                                    onClick={(e) => this.submitFn(e)}
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PartnersProfileView)